'use client';

import { BlogSection as KeziosBlogSection } from '@kezios/design-system';
import { Button } from '@mantine/core';
import { getAvatarImageFromName } from '@utils/avatar.util';
import { Article } from '@utils/blog.util';
import Image from 'next/image';
import { useFormatter, useTranslations } from 'next-intl';

export type BlogSectionProps = {
  latestBlogs: Article[];
  currentLocale: string;
};

export const BlogSection = ({
  latestBlogs,
  currentLocale,
}: BlogSectionProps) => {
  const formatter = useFormatter();
  const t = useTranslations('section.blog');

  return (
    <KeziosBlogSection
      title={t('title')}
      subtitle={t('subtitle')}
      category={t('category')}
      cta={
        <Button component="a" href="/blogs">
          {t('cta')}
        </Button>
      }
    >
      {latestBlogs.map(blog => (
        <KeziosBlogSection.Item
          key={blog.attributes.slug}
          category={blog.attributes.tag}
          image={
            <Image
              style={{ objectFit: 'cover' }}
              src={blog.attributes.thumb.data.attributes.url}
              alt={blog.attributes.title}
              fill
            />
          }
          title={blog.attributes.title}
          subtitle={blog.attributes.metaDescription}
          link={`/${currentLocale}/blogs/${blog.attributes.slug}/`}
          writtenBy={blog.attributes.userName}
          writtenAt={formatter.dateTime(new Date(blog.attributes.date), {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
          })}
          avatar={
            <Image
              src={getAvatarImageFromName(blog.attributes.userName)}
              alt={blog.attributes.userName}
              width={40}
              height={40}
            />
          }
        />
      ))}
    </KeziosBlogSection>
  );
};
